import dynamic from 'next/dynamic';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { useMount } from 'react-use';

import { useTrackViewedDiscussion } from '@air/analytics';

import { PublicDiscussionsList } from '~/components/AssetModalV2/InfoPanel/Comments/PublicDiscussionsList';
import { InitialCommentInputContainer } from '~/components/DiscussionsV2/InitialCommentInput/InitialCommentInputContainer';
import { usePublicPermissions } from '~/components/PublicPermissionsProvider';
import { useURLBoardIdSelector } from '~/hooks/useURLBoardIdSelector';
import { centralizedClipIdSelector } from '~/store/centralizedClip/selectors';
import { canEditAssetDiscussions } from '~/utils/permissions/assetPermissions';

const PublicDiscussionsForm = dynamic(
  () =>
    import('~/components/AssetModalV2/InfoPanel/Comments/PublicDiscussionsForm').then((mod) => ({
      default: mod.PublicDiscussionsForm,
    })),
  { ssr: false },
);

export const PublicComments = memo(() => {
  const { permissions } = usePublicPermissions();
  const { trackViewedDiscussion } = useTrackViewedDiscussion();
  const boardId = useURLBoardIdSelector();
  const clipId = useSelector(centralizedClipIdSelector);

  const canEditDiscussions = canEditAssetDiscussions(permissions);

  useMount(() => {
    if (clipId) {
      trackViewedDiscussion({
        boardId,
        clipId,
        location: 'asset-page',
      });
    }
  });

  return (
    <div className="flex h-full flex-col">
      <div className="flex-1 overflow-y-auto">
        <PublicDiscussionsList />
      </div>

      {canEditDiscussions && (
        <InitialCommentInputContainer>
          <PublicDiscussionsForm />
        </InitialCommentInputContainer>
      )}
    </div>
  );
});

PublicComments.displayName = 'PublicComments';
